import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "申請額", -1)
const _hoisted_2 = { class: "text-size-14 text-right" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom my-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "手数料", -1)
const _hoisted_5 = { class: "text-size-14 text-right" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom my-2" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, "振込額", -1)
const _hoisted_8 = { class: "text-size-14 text-right" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom my-2" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "振込申請", -1)
const _hoisted_11 = { class: "sub text-size-10" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-3" }, "\n            早期引出手数料は無料です。\n          ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-mild text-size-14 mt-3 mb-3" }, "\n            申請額には、以下のお仕事が含まれます。\n          ", -1)
const _hoisted_14 = { class: "d-block py-3" }
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_16 = { class: "text-size-14 text-weight-500" }
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "text-blue" }
const _hoisted_19 = { class: "mt-1" }
const _hoisted_20 = { class: "text-gray-05 text-size-12" }
const _hoisted_21 = { class: "d-flex justify-content-between mt-3" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", { class: "text-size-16 text-weight-500" }, "総計", -1)
const _hoisted_23 = { class: "text-blue text-size-16 text-weight-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_BListGroupItem = _resolveComponent("BListGroupItem")!
  const _component_BListGroup = _resolveComponent("BListGroup")!
  const _component_BCard = _resolveComponent("BCard")!
  const _component_BModal = _resolveComponent("BModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_BCard, null, {
      default: _withCtx(() => [
        _createVNode(_component_BRow, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _hoisted_1
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_2, "\n            ¥ " + _toDisplayString(_ctx.currency(_ctx.applicationAmount)), 1)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _hoisted_3,
        _createTextVNode(),
        _createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _hoisted_4
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_5, "¥ " + _toDisplayString(_ctx.currency(_ctx.fee)), 1)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _hoisted_6,
        _createTextVNode(),
        _createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _hoisted_7
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_8, "\n            ¥ " + _toDisplayString(_ctx.currency(_ctx.transferAmount)), 1)
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _hoisted_9,
        _createTextVNode(),
        _createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                (_ctx.hasMoreThanMinApplicationAmount)
                  ? (_openBlock(), _createBlock(_component_AppButton, {
                      key: 0,
                      block: true,
                      class: "mt-2",
                      variant: "success",
                      onClick: _ctx.onClickTransfer
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("\n            振込申請\n          ")
                      ], undefined, true),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createBlock(_component_AppButton, {
                      key: 1,
                      block: true,
                      disabled: true,
                      class: "disable-btn mt-3",
                      variant: "gray-03"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode(),
                        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.minApplicationAmountErrorMessage), 1)
                      ], undefined, true),
                      _: 1
                    })),
                _createTextVNode(),
                _hoisted_12
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }),
        _createTextVNode(),
        _withDirectives(_createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _hoisted_13
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasRewardTransactionHistories]
        ]),
        _createTextVNode(),
        _withDirectives(_createVNode(_component_BListGroup, null, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rewardTransactionHistories, (rewardTransactionHistory) => {
                return (_openBlock(), _createBlock(_component_BListGroupItem, {
                  key: rewardTransactionHistory.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BRow, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_BCol, { cols: "12" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.toDisplayDateFromCreatedAt(
                          rewardTransactionHistory.createdAt
                        )), 1),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("p", _hoisted_18, "\n                        + ¥\n                        " + _toDisplayString(_ctx.currency(
                            _ctx.rewardTransactionHistoryAmount(
                              rewardTransactionHistory
                            )
                          )), 1)
                                ])
                              ]),
                              _createTextVNode(),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.getRewardTransactionHistoryDetail(
                          rewardTransactionHistory
                        )), 1)
                              ])
                            ])
                          ], undefined, true),
                          _: 2
                        }, 1024)
                      ], undefined, true),
                      _: 2
                    }, 1024)
                  ], undefined, true),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ], undefined, true),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasRewardTransactionHistories]
        ])
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createVNode(_component_BModal, {
      id: "transfer-request-modal",
      title: "早期引出申請確認",
      "hide-footer": "",
      centered: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createTextVNode(),
            _createElementVNode("p", _hoisted_23, "\n            ¥ " + _toDisplayString(_ctx.currency(_ctx.transferAmount)), 1)
          ])
        ]),
        _createTextVNode(),
        _createVNode(_component_BRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppButton, {
                  block: true,
                  class: "text-weight-500 mt-3",
                  variant: "warning",
                  onClick: _ctx.onClickCancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n            キャンセル\n          ")
                  ], undefined, true),
                  _: 1
                }, 8, ["onClick"])
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(),
            _createVNode(_component_BCol, null, {
              default: _withCtx(() => [
                _createVNode(_component_AppButton, {
                  block: true,
                  class: "text-weight-500 mt-3",
                  variant: "primary",
                  onClick: _ctx.onClickConfirm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("\n            確定\n          ")
                  ], undefined, true),
                  _: 1
                }, 8, ["onClick"])
              ], undefined, true),
              _: 1
            })
          ], undefined, true),
          _: 1
        })
      ], undefined, true),
      _: 1
    })
  ]))
}